import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useImmer } from "use-immer";

import { LoginResponseBodyUserType } from "@intelligems/ig-types";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { shopifyGqlClient } from "../../providers/gqlProvider";
import { EXPERIMENT_ROUTES } from "../../routes/routes";
import { clearSnoozeShopifyScopesDialog } from "../../store/slices/appSettings";
import { clearDashboardFilters } from "../../store/slices/dashboardFilters";
import { clearGlobal } from "../../store/slices/global";
import { clearSitewideDashboardFilters } from "../../store/slices/sitewideDashboardFilters";
import { IgStorage } from "../../utils/igStorage";
import { api } from "../api";
import { organizationsKeys, userKeys } from "../queryKeys";

export const switchOrganizationByExperience = async (
  token: string,
  experienceId: string
): Promise<LoginResponseBodyUserType> => {
  const resp = await api.post<LoginResponseBodyUserType>("/v2/login", {
    token,
    experienceId,
  });
  return resp.data;
};

export const useSwitchOrganizationByExperience = () => {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  return useMutation<LoginResponseBodyUserType, Error, any, any>({
    mutationKey: [{ scope: "user" }],
    mutationFn: async (body: { token: string; experienceId: string }) =>
      switchOrganizationByExperience(body.token, body.experienceId),
    onSuccess: async (data) => {
      dispatch(clearGlobal());
      await shopifyGqlClient.resetStore();

      // eslint-disable-next-line react-compiler/react-compiler
      IgStorage.authToken = data.token;
      dispatch(clearDashboardFilters());
      dispatch(clearSitewideDashboardFilters());
      dispatch(clearSnoozeShopifyScopesDialog());
      queryClient.clear();
      queryClient.setQueryData(userKeys.all, data);
      queryClient.setQueryData(organizationsKeys.one, {
        org: data.organization,
      });
    },
    onError: (e) => {
      // ignore react query cancelled errors
      if (!e.constructor.name.includes("CancelledError")) {
        void navigate(EXPERIMENT_ROUTES.Experiments);
      }
    },
  });
};
